import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import i18next from "i18next";
import axios from "axios";
import PrepareDataTable from "./PrepareDataTable";

import "./SolutionsList.scss";
import { SolutionsListContainer } from "./SolutionsList.styled";

/**
 * CompanyList List,
 * Path - /companies
 * @see See [CompanyList Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/1855717416/Company+list)
 * @component
 */
const SolutionsList = (props) => {
  const {
    t,
    columnList,
    enquiryId,
    siteId,
    enquiryStep,
    enquiryService,
    enquirySubCategoryName,
    enquirySubCategoryId,
    setEnquiryData,
    centreId,
    displayCreateButton,
    updateRequestRefeshStatus,
    countryId,
  } = props;

  const [isRefreshList, setIsRefreshList] = useState(false);

  const updateRefeshStatus = () => {
    setIsRefreshList(true);
  };

  useEffect(() => {
    if (isRefreshList) {
      setIsRefreshList(false);
    }
  }, [isRefreshList]);

  return (
    <SolutionsListContainer className="company-list">
      <PrepareDataTable
        updateRequestRefeshStatus={updateRequestRefeshStatus}
        isRefreshList={isRefreshList}
        updateRefeshStatus={updateRefeshStatus}
        columnList={columnList}
        enquiryId={enquiryId}
        enquiryStep={enquiryStep}
        siteId={siteId}
        centreId={centreId}
        enquiryService={enquiryService}
        enquirySubCategoryName={enquirySubCategoryName}
        enquirySubCategoryId={enquirySubCategoryId}
        setEnquiryData={setEnquiryData}
        displayCreateButton={displayCreateButton}
        countryId={countryId}
      />
    </SolutionsListContainer>
  );
};

SolutionsList.propTypes = {
  t: PropTypes.func.isRequired,
  siteId: PropTypes.number,
  enquiryId: PropTypes.number,
  centreId: PropTypes.number,
  enquiryStep: PropTypes.number,
  enquiryService: PropTypes.string,
  enquirySubCategoryName: PropTypes.string,
  enquirySubCategoryId: PropTypes.number,
  setEnquiryData: PropTypes.func,
  displayCreateButton: PropTypes.bool,
  updateRequestRefeshStatus: PropTypes.func,
};

SolutionsList.defaultProps = {
  centreId: null,
  siteId: null,
  enquiryId: null,
  enquiryStep: null,
  enquiryService: null,
  setEnquiryData: null,
  displayCreateButton: true,
  updateRequestRefeshStatus: null,
  enquirySubCategoryName: null,
  enquirySubCategoryId: null,
};

export default withTranslation()(SolutionsList);
